/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useState } from 'react';
import clsx from 'clsx';
import { PageContext } from '../../../modules/context/PageContext';
import { MSR_ERROR_CONSTANTS } from '../../../modules/utils/constants';
import { nameFieldRegex } from '../../../modules/utils/regexUtils';
import { checkChinaLocale, isChinese } from '../../../modules/utils';
import { getEventKeyTypes, RadioButton, InputTextField } from '@marriott/mi-ui-library';
import { StyledStepOne } from './ReportMissingStayStepOne.styles';

export const StepOne = (props: any) => {
  const authorModelData = props?.authorModelData;
  const [showFolioQuestion, setFolioQuestion] = useState(false);
  const emailWarning = props?.errorStates?.email === MSR_ERROR_CONSTANTS?.EMAIL_WARNING;
  const phoneWarning = props?.errorStates?.phoneNumber === MSR_ERROR_CONSTANTS?.PHONE_NUMBER_WARNING;
  const pageContext = useContext(PageContext);
  const currentLocale = pageContext?.currentLocale;
  const handleRadioButtonKeyDown = (e: any) => {
    if (getEventKeyTypes(e)?.isEnterKey) {
      e.preventDefault(); // Prevent form submission when using Enter on the radio button
    }
  };

  return (
    <StyledStepOne>
      <div className="step-one mx-4 mx-md-5">
        {(props?.formFields?.thirdPartyBooking === true || props?.isUxlFailure) && (
          <div className="warningcontainer mt-4 mx-0">
            <div className="row justify-content-flexstart">
              <div className="m-message-inline error-sev2 col-12 col-md-10">
                <div className="m-message-content-wrap">
                  <div className="m-message-content">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: props?.isUxlFailure ? pageContext?.uxlErrorMessage : authorModelData?.warningMessage,
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {(emailWarning ||
          phoneWarning ||
          props?.errorStates?.firstNameBannerError ||
          props?.errorStates?.lastNameBannerError) &&
          props?.formFields?.thirdPartyBooking === false && (
            <div className="mt-4 mx-0">
              <div className="m-message-inline error-sev1">
                <div className="m-message-content-wrap">
                  <div className="m-message-content">
                    <span>{props?.authorModelData?.errMsgCommonHeader}</span>
                    <ul>
                      {emailWarning === true && <li>{props?.authorModelData?.emailAddressWarning}</li>}
                      {phoneWarning === true && <li>{props?.authorModelData?.phoneNumberWarning}</li>}
                      {props?.errorStates?.firstNameBannerError && (
                        <li>{props?.authorModelData?.firstNameBannerError}</li>
                      )}
                      {props?.errorStates?.lastNameBannerError && (
                        <li>{props?.authorModelData?.lastNameBannerError}</li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        <h2 className="step-one__heading t-subtitle-l mt-3 mb-0" data-testid="step-1">
          {authorModelData?.stepOneSectionTitle}
        </h2>

        <div
          className="step-one__question my-4"
          aria-label={`${authorModelData?.radioButtonGroupLabel}`}
          role="radiogroup"
        >
          <div className="t-font-m step1-question" data-testid="step1-question">
            {authorModelData?.questionOne}
          </div>
          <div className="step-one__question--radiobutton d-flex pt-3">
            <div className="m-radio-button-sm pr-5 mr-3 radio-button-yes">
              <RadioButton
                checked={props?.formFields?.thirdPartyBooking === true}
                radiobuttonLabel={authorModelData?.radioButtonOneLabel}
                radiobuttonName="thirdPartyBooking"
                radiobuttonId="yes"
                value="true"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  props?.setFormFields({
                    ...props?.formFields,
                    thirdPartyBooking: event.target.value === 'true',
                    digitalBillSelection: false,
                    paperBillSelection: false,
                    noBillSelection: false,
                    scannedCopySelection: false,
                    faxOrMailSelection: false,
                  });
                  props?.setIsUxlFailure(false);
                }}
                onKeyDown={event => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    props?.setFormFields({ ...props?.formFields, thirdPartyBooking: true });
                    props?.setIsUxlFailure(false);
                  }
                }}
                dataTestId="yes"
                setTabIndex={0}
              />
            </div>
            <div className="m-radio-button-sm">
              <RadioButton
                checked={props?.formFields?.thirdPartyBooking === false}
                radiobuttonLabel={authorModelData?.radioButtonTwoLabel}
                radiobuttonName="thirdPartyBooking"
                radiobuttonId="no"
                value="false"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  props?.setFormFields({ ...props?.formFields, thirdPartyBooking: event.target.value === 'true' });
                  props?.setIsUxlFailure(false);
                }}
                onKeyDown={event => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    props?.setFormFields({ ...props?.formFields, thirdPartyBooking: false });
                    props?.setIsUxlFailure(false);
                  }
                }}
                dataTestId="yes"
                setTabIndex={0}
              />
            </div>
          </div>
        </div>
        {!props?.fieldNameReverse ? (
          //firstName and lastName
          <div
            className={clsx(
              'step-one__row',
              'row',
              'mb-0',
              'mb-md-4',
              props?.formFields?.thirdPartyBooking !== false ? 'blur' : ''
            )}
          >
            <div className="col-12 col-md-6 mb-5 mb-md-0">
              <div
                className={clsx(
                  'm-input-field',
                  props?.formFields?.thirdPartyBooking !== false ? 'is-disabled' : '',
                  props?.errorStates?.firstName ||
                    props?.errorStates?.firstNameRegExp ||
                    props?.errorStates?.firstNameBannerError
                    ? 'is-error'
                    : '',
                  props?.formFields?.firstName ? 'is-active' : ''
                )}
              >
                <InputTextField
                  infoLabel="fname"
                  label={authorModelData?.firstNameFieldLabel}
                  inputValue={props?.formFields?.firstName}
                  inputMaxLength={20}
                  className="m-input-field is-active"
                  disabled={props?.formFields?.thirdPartyBooking !== false}
                  testId="fname"
                  getLabelProps={() => ({
                    htmlFor: 'firstname',
                  })}
                  getInputProps={() => ({
                    autoComplete: 'off',
                    id: 'firstname',
                  })}
                  getInputValue={(value: string) => {
                    props?.setFormFields({
                      ...props?.formFields,
                      firstName: value?.trim(),
                      folioStayAndPayApplicable: true,
                    });
                    setFolioQuestion(true);
                    props?.setErrorStates?.({
                      ...props?.errorStates,
                      firstName: '',
                      firstNameRegExp:
                        value?.trim() && checkChinaLocale(currentLocale || '')
                          ? !nameFieldRegex.test(value) && !isChinese(value)
                          : !nameFieldRegex.test(value),
                    });
                  }}
                  messageToShow={
                    props?.errorStates?.firstNameRegExp || props?.errorStates?.firstNameBannerError
                      ? authorModelData?.nameInlineErrorMsg
                      : props?.errorStates?.firstName
                      ? authorModelData?.firstNameErrorMessage
                      : ''
                  }
                  showErrorMessage={
                    !!props?.errorStates?.firstNameRegExp ||
                    !!props?.errorStates?.firstName ||
                    !!props?.errorStates?.firstNameBannerError
                  }
                  messageClass="validation-msg"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-5 mb-md-0">
              <div
                className={clsx(
                  'm-input-field',
                  props?.formFields?.thirdPartyBooking !== false ? 'is-disabled' : '',
                  props?.errorStates?.lastName ||
                    props.errorStates?.lastNameRegExp ||
                    props?.errorStates?.lastNameBannerError
                    ? 'is-error'
                    : '',
                  props?.formFields?.lastName ? 'is-active' : ''
                )}
              >
                <InputTextField
                  infoLabel="lname"
                  label={authorModelData?.lastNameFieldLabel}
                  inputValue={props?.formFields?.lastName}
                  inputMaxLength={25}
                  className="m-input-field is-active"
                  disabled={props?.formFields?.thirdPartyBooking !== false}
                  testId="lname"
                  getLabelProps={() => ({
                    htmlFor: 'lastname',
                  })}
                  getInputProps={() => ({
                    autoComplete: 'off',
                    id: 'lastname',
                  })}
                  getInputValue={(value: string) => {
                    props?.setFormFields({
                      ...props?.formFields,
                      lastName: value?.trim(),
                      folioStayAndPayApplicable: true,
                    });
                    setFolioQuestion(true);
                    props?.setErrorStates?.({
                      ...props?.errorStates,
                      lastName: '',
                      lastNameRegExp:
                        value?.trim() && checkChinaLocale(currentLocale || '')
                          ? !nameFieldRegex.test(value) && !isChinese(value)
                          : !nameFieldRegex.test(value),
                    });
                  }}
                  messageToShow={
                    props?.errorStates?.lastNameRegExp || props?.errorStates?.lastNameBannerError
                      ? authorModelData?.nameInlineErrorMsg
                      : props?.errorStates?.lastName
                      ? authorModelData?.lastNameErrorMessage
                      : ''
                  }
                  showErrorMessage={
                    !!props?.errorStates?.lastNameRegExp ||
                    !!props?.errorStates?.lastName ||
                    !!props?.errorStates?.lastNameBannerError
                  }
                  messageClass="validation-msg"
                />
              </div>
            </div>
          </div>
        ) : (
          //lastNmae and firstName
          <div
            className={clsx(
              'step-one__row',
              'row',
              'mb-0',
              'mb-md-4',
              props?.formFields?.thirdPartyBooking !== false ? 'blur' : ''
            )}
          >
            <div className="col-12 col-md-6 mb-5 mb-md-0">
              <div
                className={clsx(
                  'm-input-field',
                  props?.formFields?.thirdPartyBooking !== false ? 'is-disabled' : '',
                  props?.errorStates?.lastName ||
                    props.errorStates?.lastNameRegExp ||
                    props.errorStates?.lastNameBannerError
                    ? 'is-error'
                    : '',
                  props?.formFields?.lastName ? 'is-active' : ''
                )}
              >
                <InputTextField
                  infoLabel="lname"
                  label={authorModelData?.lastNameFieldLabel}
                  inputValue={props?.formFields?.lastName}
                  inputMaxLength={25}
                  className="m-input-field is-active"
                  disabled={props?.formFields?.thirdPartyBooking !== false}
                  testId="lname"
                  getLabelProps={() => ({
                    htmlFor: 'lastname',
                  })}
                  getInputProps={() => ({
                    autoComplete: 'off',
                    id: 'lastname',
                  })}
                  getInputValue={(value: string) => {
                    props?.setFormFields({
                      ...props?.formFields,
                      lastName: value?.trim(),
                      folioStayAndPayApplicable: true,
                    });
                    setFolioQuestion(true);
                    props?.setErrorStates?.({
                      ...props?.errorStates,
                      lastName: '',
                      lastNameRegExp:
                        value?.trim() && checkChinaLocale(currentLocale || '')
                          ? !nameFieldRegex.test(value) && !isChinese(value)
                          : !nameFieldRegex.test(value),
                    });
                  }}
                  messageToShow={
                    props?.errorStates?.lastNameRegExp || props?.errorStates?.lastNameBannerError
                      ? authorModelData?.nameInlineErrorMsg
                      : props?.errorStates?.lastName
                      ? authorModelData?.lastNameErrorMessage
                      : ''
                  }
                  showErrorMessage={
                    !!props?.errorStates?.lastNameRegExp ||
                    !!props?.errorStates?.lastName ||
                    !!props?.errorStates?.lastNameBannerError
                  }
                  messageClass="validation-msg"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-5 mb-md-0">
              <div
                className={clsx(
                  'm-input-field',
                  props?.formFields?.thirdPartyBooking !== false ? 'is-disabled' : '',
                  props?.errorStates?.firstName ||
                    props?.errorStates?.firstNameRegExp ||
                    props?.errorStates?.firstNameBannerError
                    ? 'is-error'
                    : '',
                  props?.formFields?.firstName ? 'is-active' : ''
                )}
              >
                <InputTextField
                  infoLabel="fname"
                  label={authorModelData?.firstNameFieldLabel}
                  inputValue={props?.formFields?.firstName}
                  inputMaxLength={20}
                  className="m-input-field is-active"
                  disabled={props?.formFields?.thirdPartyBooking !== false}
                  testId="fname"
                  getLabelProps={() => ({
                    htmlFor: 'firstname',
                  })}
                  getInputProps={() => ({
                    autoComplete: 'off',
                    id: 'firstname',
                  })}
                  getInputValue={(value: string) => {
                    props?.setFormFields({
                      ...props?.formFields,
                      firstName: value?.trim(),
                      folioStayAndPayApplicable: true,
                    });
                    setFolioQuestion(true);
                    props?.setErrorStates?.({
                      ...props?.errorStates,
                      firstName: '',
                      firstNameRegExp:
                        value?.trim() && checkChinaLocale(currentLocale || '')
                          ? !nameFieldRegex.test(value) && !isChinese(value)
                          : !nameFieldRegex.test(value),
                    });
                  }}
                  messageToShow={
                    props?.errorStates?.firstNameRegExp || props?.errorStates?.firstNameBannerError
                      ? authorModelData?.nameInlineErrorMsg
                      : props?.errorStates?.firstName
                      ? authorModelData?.firstNameErrorMessage
                      : ''
                  }
                  showErrorMessage={
                    !!props?.errorStates?.firstNameRegExp ||
                    !!props?.errorStates?.firstName ||
                    !!props?.errorStates?.firstNameBannerError
                  }
                  messageClass="validation-msg"
                />
              </div>
            </div>
          </div>
        )}
        <div
          className={clsx(
            'step-one__row',
            'row',
            'mb-0',
            'mb-md-4',
            props?.formFields?.thirdPartyBooking !== false ? 'blur' : ''
          )}
        >
          <div className="col-12 col-md-6 mb-5 mb-md-0">
            <div
              className={clsx(
                'm-input-field',
                props?.formFields?.thirdPartyBooking !== false ? 'is-disabled' : '',
                props?.errorStates?.phoneNumber ? 'is-error' : '',
                props?.formFields?.phoneNumber ? 'is-active' : ''
              )}
            >
              <InputTextField
                infoLabel="phone"
                label={authorModelData?.phoneNumberFieldLabel}
                inputValue={props?.formFields?.phoneNumber}
                inputMaxLength={16}
                className="m-input-field is-active"
                disabled={props?.formFields?.thirdPartyBooking !== false}
                testId="phone"
                getLabelProps={() => ({
                  htmlFor: 'phonenumber',
                })}
                getInputProps={() => ({
                  autoComplete: 'off',
                  id: 'phonenumber',
                })}
                getInputValue={(value: string) => {
                  props?.setFormFields({
                    ...props?.formFields,
                    phoneNumber: value?.trim(),
                  });
                }}
                messageToShow={
                  props?.formFields?.phoneNumber?.trim()?.length === 0
                    ? authorModelData?.phoneNumberErrorMessage
                    : props?.formFields?.phoneNumber?.trim()?.length < 7
                    ? authorModelData?.phoneNumberWarning
                    : ''
                }
                showErrorMessage={!!props?.errorStates?.phoneNumber}
                messageClass="validation-msg"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 mb-5 mb-md-0">
            <div
              className={clsx(
                'm-input-field',
                props?.formFields?.thirdPartyBooking !== false ? 'is-disabled' : '',
                props?.errorStates?.email ? 'is-error' : '',
                props?.formFields?.emailAddress ? 'is-active' : ''
              )}
            >
              <InputTextField
                infoLabel="email"
                label={authorModelData?.emailAddressFieldLabel}
                inputValue={props?.formFields?.emailAddress}
                inputMaxLength={80}
                className="m-input-field is-active"
                disabled={props?.formFields?.thirdPartyBooking !== false}
                testId="email"
                getLabelProps={() => ({
                  htmlFor: 'emailaddress',
                })}
                getInputProps={() => ({
                  autoComplete: 'off',
                  id: 'emailaddress',
                })}
                getInputValue={(value: string) => {
                  props?.setFormFields({
                    ...props?.formFields,
                    emailAddress: value?.trim(),
                  });
                }}
                messageToShow={
                  props?.formFields?.emailAddress?.trim()?.length === 0
                    ? authorModelData?.emailAddressErrorMessage
                    : props?.formFields?.emailAddress?.trim()?.length < 5
                    ? authorModelData?.emailAddressWarning
                    : ''
                }
                showErrorMessage={!!props?.errorStates?.email}
                messageClass="validation-msg"
              />
            </div>
          </div>
        </div>

        {showFolioQuestion && props?.formFields?.thirdPartyBooking !== true && (
          <div
            className="step-one__folioquestion mt-4 mb-5"
            role="radiogroup"
            aria-label={`${authorModelData?.optionGroupLabel}`}
          >
            <div className="t-font-m">{authorModelData?.folioQuestionStatement}</div>
            <div className="step-one__question--radiobutton d-flex pt-3">
              <div className="m-radio-button-sm pr-5 mr-3 radio-button-yes">
                <RadioButton
                  checked={props?.formFields?.folioStayAndPay === 'Yes'}
                  radiobuttonLabel={authorModelData?.optionOneLabel}
                  radiobuttonName="folioStayAndPayApplicable"
                  radiobuttonId="folio_yes"
                  value="true"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props?.setFormFields({
                      ...props?.formFields,
                      folioStayAndPayApplicable: event.target.value === 'true',
                      folioStayAndPay: 'Yes',
                    });
                  }}
                  onKeyDown={event => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      event.stopPropagation();
                      props?.setFormFields({
                        ...props?.formFields,
                        folioStayAndPayApplicable: true,
                      });
                    }
                  }}
                  dataTestId="folio_yes"
                  setTabIndex={0}
                />
              </div>
              <div className="m-radio-button-sm">
                <RadioButton
                  checked={props?.formFields?.folioStayAndPay === 'No'}
                  radiobuttonLabel={authorModelData?.optionTwoLabel}
                  radiobuttonName="folioStayAndPayApplicable"
                  radiobuttonId="folio_no"
                  value="false"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    props?.setFormFields({
                      ...props?.formFields,
                      folioStayAndPayApplicable: event.target.value === 'false',
                      folioStayAndPay: 'No',
                    });
                  }}
                  onKeyDown={event => {
                    handleRadioButtonKeyDown(event);
                    props?.setFormFields({
                      ...props?.formFields,
                      folioStayAndPayApplicable: true,
                    });
                  }}
                  dataTestId="folio_no"
                  setTabIndex={0}
                />
              </div>
            </div>
          </div>
        )}
        {showFolioQuestion &&
          props?.formFields?.thirdPartyBooking !== true &&
          props?.formFields?.folioStayAndPay === 'No' && (
            <div className="warningcontainer mt-4 mx-0">
              <div className="row justify-content-flexstart">
                <div className="m-message-inline error-sev2 col-12 col-md-10">
                  <div className="m-message-content-wrap">
                    <div className="m-message-content">
                      <span dangerouslySetInnerHTML={{ __html: authorModelData?.secondWarningMessage }}></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    </StyledStepOne>
  );
};
